import { useState, Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import { ReactTable } from "components/Table";
import SelectBox from "components/elements/selectBox";
import { getDetailCampaign } from "actions/promotionActions";
import ReactImageMagnify from 'react-image-magnify';
import { formatterCreateAt } from "components/Function";

const ModalCampaign = ({ shopId, activity_type, onClose, onSubmit, getDetailCampaign, formatterCreateAt }) => {
    const { t } = useTranslation();
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [filter, setFilter] = useState({});
    const [list, setList] = useState([]);
    const [products_selected, setProductsSelected] = useState([]);
    const [promotions, setPromotions] = useState([]);
    const [activitys, setActivity] = useState([]);

    useEffect(() => {
        if (shopId && activity_type) {
            async function fetchData() {
                // You can await here
                await getDetailCampaign({ shopId, activity_type, page, sizeperpage: sizePerPage, search: searchText, filter }).then((data) => {
                    setList(data?.list)
                    setTotalSize(data?.totalsize)
                    setPromotions(data?.campaigns?.map((v, i) => ({ value: v?.promotion_id, label: `${v?.title} (${v?.promotion_id}%)` })) || [])
                    setActivity(data?.activities?.map((v, i) => ({ value: v?.activity_id, label: (v?.activity_id !== "0" ? v?.activity_id : "Waitting run...") })) || [])
                })
                // ...
            }
            fetchData();
        }
    }, [shopId, activity_type, getDetailCampaign, page, sizePerPage, searchText, filter]);

    const handleSubmit = async () => {
        onSubmit?.();
        onClose?.();
    };

    const columns = [{
        dataField: '_id',
        text: "",
        sort: true,
        formatter: (cell, row, rowIndex) => rowIndex + 1
    }, {
        dataField: 'main_images',
        text: t("Product Name"),
        sort: true,
        formatter: (cell, row) => {
            return (
                <div className="symbol symbol-50px me-2 mt-4 " style={{ verticalAlign: "top" }}>  {cell?.[0] && cell?.[0] !== "" ? <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: cell?.[0] }, largeImage: { src: cell?.[0], width: 400, height: 400 }, enlargedImageContainerDimensions: { width: '800%', height: '800%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} /> : <img src={require("components/assets/media/misc/image.png")} className="" alt="" />}
                </div>
            );
        },
    }, {
        dataField: 'title',
        text: t("Product Name"),
        sort: true,
    }, {
        dataField: 'promotion_title',
        text: t("Campaign Name"),
        sort: true
    }, {
        dataField: 'activity_id',
        text: t("Activity ID"),
        sort: true,
        formatter: (cell, row) => {
            return (
                <>
                    {cell !== "0" ? <div>
                        <div>
                            {`${cell}`}
                        </div>
                        <div data-tooltip-id="my-tooltip"
                            data-tooltip-content={t("Time end!")} className="text-bold text-danger mt-2">
                            {formatterCreateAt(row?.expired_at)}
                        </div>
                    </div> : "Waitting run..."}
                </>
            );
        },
    }, {
        dataField: 'activity_price_amount',
        text: t("Sale Off"),
        sort: true,
        formatter: (cell, row) => {
            return (
                <>
                    {cell}%
                </>
            );
        },
    },];

    const groupButton = () => {
        return (
            <div className="mb-5 d-flex gap-2 flex-wrap">
                <SelectBox
                    options={promotions}
                    name="filter_promotion_id"
                    placeholder="Filter Campaing Config"
                    value={filter.promotion_id || ""}
                    onChange={(data) =>
                        setFilter((prev) => ({
                            ...prev,
                            promotion_id: data?.value || "",
                        }))
                    }
                />
                <SelectBox
                    options={activitys}
                    name="filter_activity_id"
                    placeholder="Filter Activity"
                    value={filter.activity_id || ""}
                    onChange={(data) =>
                        setFilter((prev) => ({
                            ...prev,
                            activity_id: data?.value || "",
                        }))
                    }
                />
            </div>
        );
    }

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page || 1);
            setSizePerPage(sizePerPage);
        }
    }

    const removeSelect = (arr, value) => {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    }

    const onSelect = (row, isSelect) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp.push(row._id);
        } else {
            products_selected_tmp = removeSelect(products_selected_tmp, row._id);
        }
        var new_arr = JSON.stringify(products_selected_tmp);
        setProductsSelected(JSON.parse(new_arr));
    };

    const onSelectAll = (isSelect, row) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp = row.map((v, i) => v._id);
        } else {
            products_selected_tmp = [];
        }
        setProductsSelected(products_selected_tmp);
    };

    const selectRow = {
        mode: 'checkbox',
        clickToSelect: false,
        selected: products_selected,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
            <div className="d-flex">
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) {
                            input.indeterminate = indeterminate;
                            input.checked = checked;
                        }
                    }}
                    onChange={onChange}
                />
            </div>
        ),
    };

    const sizePerPageList = [
        {
            text: '10', value: 10
        },
        {
            text: '50', value: 50
        },
        {
            text: '100', value: 100
        },
        {
            text: '150', value: 150
        },
        {
            text: '200', value: 200
        },
        {
            text: 'All', value: totalSize || 50
        }
    ];

    return (
        <Fragment>
            <Modal centered={true} size="xl" toggle={onClose} isOpen={!!shopId}>
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Detail Campaign")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i className="ki-outline ki-cross fs-1" onClick={() => { onClose(); }} ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="al-variants-table">
                        <ReactTable columns={columns} data={list} groupButton={groupButton} handleTableChange={handleTableChange} page={page} sizePerPage={sizePerPage} totalSize={totalSize} alClassName="table-layout-inherit" isSelectRow={true} selectRow={selectRow} sizePerPageList={sizePerPageList} />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="submit" id="kt_modal_users_search_submit" className="btn btn-primary" onClick={handleSubmit}  >{t("Close")}</button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { getDetailCampaign, formatterCreateAt })(ModalCampaign);
